import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface ChatBubbleProps {
  children: React.ReactNode;
  isUser?: boolean;
  className?: string;
  animate?: boolean;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({
  children,
  isUser = false,
  className,
  animate = true
}) => {
  const Wrapper = animate ? motion.div : 'div';
  const animationProps = animate ? {
    initial: { opacity: 0, y: 10, scale: 0.95 },
    animate: { opacity: 1, y: 0, scale: 1 },
    transition: { duration: 0.3, ease: "easeOut" }
  } : {};

  return (
    <Wrapper
      {...animationProps}
      className={cn(
        "max-w-[85%] rounded-2xl px-4 py-3.5 min-h-[2.75rem]",
        isUser 
          ? "ml-auto bg-primary text-primary-foreground rounded-br-md" 
          : "mr-auto bg-muted/60 text-foreground rounded-bl-md border border-border/50",
        className
      )}
    >
      {children}
    </Wrapper>
  );
};
